import React from "react"
export function PriceDrop(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__price-drop"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M10.99 3l.018 8.56h2.984c.09 0 .176.022.253.063l.072.048c.192.15.236.403.117.599l-.052.07-3.992 4.489-.065.06a.534.534 0 01-.65 0l-.065-.06-3.992-4.489a.458.458 0 01-.118-.304c0-.233.18-.428.416-.468l.092-.008h2.994l-.018-8.558L10.99 3z"
          id="prefix__fill-arrow"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
